
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brandstudio/[partner]/[slug]",
      function () {
        return require("private-next-pages/brandstudio/[partner]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brandstudio/[partner]/[slug]"])
      });
    }
  